import BaseClass from "../BaseClass.js";

export default class PortalNotification extends BaseClass {

    constructor(element) {
        super(element);

        this.pending = false;
        this.scrollListener = null;
        this.notificationReadListener = null;

        this.init();
    }

    init() {

        const mySelf = this;

        this.scrollListener = function (event) {
            mySelf.onScrolled(event);
        }

        this.notificationReadListener = function () {
            mySelf.updateIsRead();
        }

        $(document).on('notification:read', this.notificationReadListener);

        if (this.isVisible($(window), this.$element), 50) {
            this.saveIsRead();
        } else {
            $(document).on('content:scrolled', {mySelf: mySelf}, this.scrollListener)
        }
    }

    onScrolled(event) {

        let mySelf = event.data.mySelf;

        if (this.isVisible($(window), mySelf.$element)) {
            mySelf.saveIsRead();
        }
    }

    saveIsRead() {
        let mySelf = this;

        if (mySelf.pending) {
            return;
        }

        this.pending = true;

        let url = this.$element.attr('data-url');
        if (url === undefined) {
            return false;
        }

        let postData = {
            id: this.$element.data('element-id')
        };

        let jqxhr = $.post(url, postData, function () {
            // nix
        }, 'json')
            .done(function (response) {

                if (response.success) {
                    mySelf.updateIsRead();
                    $(document).trigger('notification:read');
                }
            });

        $(document).off('content:scrolled', mySelf.scrollListener);
    }

    updateIsRead() {
        this.$element.removeClass('unread')
            .attr('data-state', 'read');
    }
}